import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GROLOG_ORDER_URL,
  GROLOG_URL,
} from "../../../../../constant/apiConstant";
import axios from "axios";
import { useEffect } from "react";
import { ROUTES } from "../../../../../constant/routeConstant";
import _ from "lodash";
import ModalSuccessAdd from "../../../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../../../component/modal/ModalFailedDelete";
import Delete from "../../../../../component/modal/ModalDelete";
import Breadcumbs from "../../../../../component/page-components/breadcumbs/breadcumbs";
import { AutoComplete, Input, Tooltip } from "antd";
import { CloseIconSearch, DetailIcon, SearchIcon } from "../../../../../asset";
import PrimaryButton from "../../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../../component/button/SecondaryButton";
import { AddIcon } from "../../../../../asset/icons";
import CustomTableScroll from "../../../../../component/table/CustomTableScroll";
import CustomPaging from "../../../../../component/pagination/pagination";
import style from "./ListTripPlanning.module.css";
import Checkbox from "antd/es/checkbox/Checkbox";
import ModalTrip from "../../../../../component/modal/ModalTrip";
import * as TripPlanningServices from "../../../../../service/order/tripPlanningServices";
import SelectSearch from "../../../../../component/input/SelectSearch";

const ListTripPlanning = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_ORDER_URL;

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [isFilter, setIsfilter] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [searchRecommendation, setSearchRecommedation] = useState("");
  const [listRecommendation, setListRecommendation] = useState([]);
  const [filter, setFilter] = useState("");
  const [load, setLoad] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [dataCheck, setDataCheck] = useState([]);
  const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messages, setMessages] = useState("");

  const doGet = async (endpoint, tkn, params) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetParam = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const onStart = async () => {
    let cek = [];
    dataCheck?.map((el) => {
      cek.push({
        id: el.id,
        updated_at: el.updated_at,
      });
    });
    // let list_trip = { list_trip: cek };
    let depot_id = selectedDepotId;

    const payload = {
      depot_id,
      list_trip: cek,
    };

    const { status, message } = await TripPlanningServices.approve(
      token,
      null,
      payload,
      null
    );
    if (status) {
      setMessages(message);
      setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
    } else {
      setMessages(message);
      setFailedModalOpen(true);
      setStartOpen(false);
    }
  };

  const onEnd = async () => {
    let cek = [];
    dataCheck?.map((el) => {
      cek.push({
        id: el.id,
        updated_at: el.updated_at,
      });
    });
    // let list_trip = { list_trip: cek };
    let depot_id = selectedDepotId;

    const payload = {
      depot_id,
      list_trip: cek,
    };

    const { status, message } = await TripPlanningServices.reject(
      token,
      null,
      payload,
      null
    );
    if (status) {
      setMessages(message);
      setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
    } else {
      setMessages(message);
      setFailedModalOpen(true);
      setStartOpen(false);
    }
  };

  const [listDropdown, setListDropdown] = useState([]);
  const dispatch = useDispatch();

  const [dropdownListLoading, setDropdownListLoading] = useState(false);
  const [selectedDepotId, setSelectedDepotId] = useState();

  const doGetListDropdown = async (page, keyword = "", flag = "list") => {
    setDropdownListLoading(true);

    let param = {
      page: page,
      limit: 10,
      filter: keyword !== "" ? `depot_name lk ${keyword}` : "",
    };

    try {
      const response = await doGetParam(
        "/depot-configuration/dropdown",
        token,
        param,
        dispatch,
        null
      );
      if (response) {
        if (flag === "list") {
          if (listDropdown.length === 0) {
            setSelectedDepotId(response.data.payload.data[0].id);
            setListDropdown(response.data.payload.data);
          } else {
            let tempListDropdown = [...listDropdown];
            response.data.payload.data.map((item) =>
              tempListDropdown.push(item)
            );
            setListDropdown(tempListDropdown);
          }
          setDropdownListLoading(false);
        } else if (flag === "searchList") {
          setListDropdown(response.data.payload.data);
        }
      }
    } catch (error) {
      return error;
    }
  };

  const fetchData = async (data, pages) => {
    let tkn = token;
    setLoad(true);
    let res = await doGet(
      `/trip-planning?page=${
        pages ? pages : page
      }&limit=${limit}&filter=depot_id eq ${
        selectedDepotId ? selectedDepotId : 1
      }${
        !data
          ? ""
          : data
          ? ", trip_plan_name lk " + data
          : data
          ? ", trip_plan_name lk " + data
          : ""
      }&${param}`,
      tkn
    );
    let init = await doGet(
      `/trip-planning/initiate?page=${
        pages ? pages : page
      }&limit=${limit}&filter=depot_id eq ${
        selectedDepotId ? selectedDepotId : 1
      }${data ? ", trip_plan_name lk " + data : ""}&${param}`,
      tkn
    );
    setListData(
      res?.data?.payload?.data === null
        ? null
        : res?.data?.payload?.data.map((value) => ({
            ...value,
            checked: false,
          }))
    );

    setInitiate(init?.data?.payload?.data);
    setLoad(false);
  };

  const handleChange = (id) => {
    setSelectedDepotId(id);
    setPage(1);
    fetchData();
  };

  useEffect(() => {
    doGetListDropdown(depotListPage);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepotId, page, limit]);

  const handleDetail = (result) => {
    navigate(ROUTES.TRIP_PLANNING.DETAIL, { state: { data: result } });
  };

  const checkOne = (event, result) => {
    let value = event.target.checked;
    console.log("valchk", value);
    let id = result.id;
    let search = _.find(listData, (el) => el.id == id);
    let findIndex = _.findIndex(listData, (el) => el.id == id);
    let data = _.some(dataCheck, search);
    if (data) {
      let checkedFalse = [...listData];
      checkedFalse[findIndex] = {
        ...checkedFalse[findIndex],
        checked: false,
      };
      _.remove(dataCheck, search);
      setIsChecked(false);
      setListData(checkedFalse);
    } else {
      let checkedTrue = [...listData];
      checkedTrue[findIndex] = {
        ...checkedTrue[findIndex],
        checked: true,
      };
      _.pull(dataCheck, search);
      dataCheck.push(checkedTrue[findIndex]);
      setListData(checkedTrue);
      if (dataCheck.length === 10) {
        setIsChecked(true);
      }
    }
  };

  const dataSource = listData
    ? listData?.map((result) => ({
        checkbox: (
          <div className={style.selectOptionContainer}>
            <Checkbox
              onChange={(v) => checkOne(v, result)}
              checked={isChecked || result.checked}
              disabled={result?.status !== "Waiting Approval" ? true : false}
            />
          </div>
        ),
        trip_plan_id: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.id}
          </span>
        ),
        plan_name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.trip_plan_name}
          </span>
        ),
        total_order: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.order}
          </span>
        ),
        total_da: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.delivery_associate}
          </span>
        ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.status === "Waiting Approval" ? (
              <div className="bg-[#F8AC301A] w-[10rem] flex justify-center items-center rounded-[9px]">
                <p className="font-roboto font-medium text-base text-[#F8AC30]">
                  {" "}
                  {result?.status}{" "}
                </p>
              </div>
            ) : result?.status === "Reject" ? (
              <div className="bg-[#FF00001A] w-[4rem] flex justify-center items-center rounded-[9px]">
                <p className="font-roboto font-medium text-base text-[#FF0000]">
                  {" "}
                  {result?.status}{" "}
                </p>
              </div>
            ) : result?.status === "Approved" ? (
              <div className="bg-[#57C22D1A] w-[5.175rem] flex justify-center items-center rounded-[9px]">
                <p className="font-roboto font-medium text-base text-[#57C22D]">
                  {" "}
                  {result?.status}{" "}
                </p>
              </div>
            ) : (
              <div className="bg-[#9F9F9F1A] w-[7rem] flex justify-center items-center rounded-[9px]">
                <p className="font-roboto font-medium text-base text-[#9F9F9F]">
                  {" "}
                  {result?.status}{" "}
                </p>
              </div>
            )}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                onClick={() => handleDetail(result)}
                disabled={
                  result?.status === "On Process" ||
                  result?.status === "Process Failed"
                    ? true
                    : false
                }
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  const ListColumn = [
    {
      width: 50,
      title: <div className={style.selectOptionContainer}></div>,
      dataIndex: "checkbox",
      key: "checkbox",
      render: (checkbox) => <span>{checkbox}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Trip Plan ID")}
        </span>
      ),
      width: 250,
      dataIndex: "trip_plan_id",
      key: "trip_plan_id",
      render: (trip_plan_id) => <span>{trip_plan_id}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Plan Name")}
        </span>
      ),
      width: 250,
      dataIndex: "plan_name",
      key: "plan_name",
      render: (plan_name) => <span>{plan_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Total Order")}
        </span>
      ),
      width: 250,
      dataIndex: "total_order",
      key: "total_order",
      render: (total_order) => <span>{total_order}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Total DA")}
        </span>
      ),
      width: 250,
      dataIndex: "total_da",
      key: "total_da",
      render: (total_da) => <span>{total_da}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Status")}
        </span>
      ),
      width: 250,
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      // fixed: "right",
      render: (action) => action,
    },
  ];

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (page, limit, filters) => {
    if (filters.length >= 1) {
      let tkn = token;
      let res = await doGet(
        `/trip-planning/search?page=${page}&limit=${limit}&filter=depot_id eq ${selectedDepotId}, trip_plan_name lk ${filters}&${param}`,
        tkn
      );
      // console.log(res?.data?.payload?.data);
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value);
    setIsfilter(true);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setFilter(data);
    fetchData(data, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData("");
    setPage(1);
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setStartOpen(false);
    setEndOpen(false);
    setMessages("");
    setDataCheck([]);
    fetchData();
  };

  const [depotKeyword, setDepotKeyword] = useState("");
  const [depotListPage, setDepotListPage] = useState(1);

  const onScroll = (event, namespace) => {
    let target = event.target;
    switch (namespace) {
      case "depotList":
        if (
          target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight ||
          (target.scrollHeight - Math.ceil(target.scrollTop) ===
            target.clientHeight + 1 &&
            !dropdownListLoading)
        ) {
          doGetListDropdown(depotListPage + 1, depotKeyword);
          setDepotListPage(depotListPage + 1);
          target.scrollTo(0, target.scrollHeight);
        }
        break;

      default:
        break;
    }
  };

  const onSearchDDS = (keyword, namespace) => {
    switch (namespace) {
      case "depotList":
        setDepotKeyword(keyword);
        if (keyword.length >= 3 || keyword === "") {
          doGetListDropdown(1, keyword, "searchList");
        }
        setDepotListPage(1);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <ModalTrip
        visible={startOpen}
        message={`The trip status will appear on "All Trip Menu"`}
        title="Approve Trip?"
        type="Approve"
        onClick={() => setStartOpen(false)}
        action={() => onStart()}
      />
      <ModalTrip
        visible={endOpen}
        message={`The trip status will change to "Rejected"`}
        title="Reject Trip"
        type="Reject"
        onClick={() => setEndOpen(false)}
        action={() => onEnd()}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messages}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <Delete
        data={data.updated_at}
        id={data.trip_id}
        delete={showDelete}
        title={data.first_name}
        url={"trip"}
        action={() => setShowDelete(false)}
        route={ROUTES.TRIP_PLANNING.LIST}
        refresh={() => fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Order`}
          menuLevel2={`Routes`}
          menuLevel3={`Trip Planning`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("Trip Planning")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <div className="flex h-[47px] mr-1">
            <AutoComplete
              options={options}
              value={searchRecommendation}
              onChange={(value) => onSearchRecommendation(value)}
              onSelect={(value) => onSelectRecommendation(value)}
              style={{ marginRight: "16px" }}
            >
              <Input
                placeholder={t("Search Trip Name")}
                suffix={
                  <img
                    onClick={filter ? () => onClearRecommendation() : null}
                    src={filter ? CloseIconSearch : SearchIcon}
                    alt="search"
                  />
                }
                value={searchRecommendation}
                width={350}
                className="w-[350px] h-[47px]"
              />
            </AutoComplete>

            {listDropdown?.length !== 0 ? (
              <SelectSearch
                onScroll={(event) => onScroll(event, "depotList")}
                keyword={depotKeyword}
                onChange={(value) => onSearchDDS(value, "depotList")}
                onSelect={(value) => handleChange(value)}
                width={292}
                options={listDropdown}
                loading={dropdownListLoading}
                defaultValue={listDropdown[0]?.value}
              />
            ) : null}

            <SecondaryButton
              text={t("Reject Trip")}
              disabled={!dataCheck?.length}
              styles="ml-[24px] mr-[16px]"
              action={() => setEndOpen(true)}
            />
            <PrimaryButton
              text={t("Approve Trip")}
              disabled={!dataCheck?.length}
              action={() => setStartOpen(true)}
            />
          </div>

          <PrimaryButton
            action={() =>
              navigate(ROUTES.TRIP_PLANNING.ADD, {
                state: selectedDepotId,
              })
            }
            text={t("Add Trip Planning")}
            prefixIcon={<AddIcon />}
          />
        </div>
        <div className={style.tableContainer}>
          <CustomTableScroll
            columns={ListColumn}
            data={dataSource}
            showPagination={false}
          />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a, b) => handlePagination(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ListTripPlanning;
